"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lodash = _interopRequireDefault(require("lodash"));
var _constants = _interopRequireDefault(require("./constants"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TYPE_SORT = {
  ASC: 'asc',
  DESC: 'desc'
};
var TYPE_COMPARE = {
  BASE: 'base',
  ACCENT: 'accent',
  CASE: 'case',
  VARIANT: 'variant'
};
var SortUtil = {
  /**
   * Defines the sort order of boolean values.
   * @param  {boolean, null} value1 The first element for comparison.
   * @param  {boolean, null} value2 The second element for comparison.
   * @param  {string} order
   * @return {number}
   * Return 0 if value1 = value2
   * In ASC order return 1, if value1 > value2, otherwise return -1
   * In DESC order return -1, if value1 > value2, otherwise return 1
   */
  compareBoolean: function compareBoolean(value1, value2, order) {
    var boolean1 = Boolean(value1);
    var boolean2 = Boolean(value2);
    if (boolean1 === boolean2) {
      return 0;
    }
    if (order === TYPE_SORT.ASC) {
      return boolean1 ? 1 : -1;
    }
    return boolean1 ? -1 : 1;
  },
  /**
   * Defines the sort order of number values.
   * @param  {number} value1
   * @param  {number} value2
   * @param  {string} order
   * @return {number}
   * Return 0 if value1 = value2
   * In ASC order return 1, if value1 > value2, otherwise return -1
   * In DESC order return -1, if value1 > value2, otherwise return 1
   */
  compareNumber: function compareNumber(value1, value2, order) {
    if (value1 === value2) {
      return 0;
    }
    if (order === TYPE_SORT.ASC) {
      return value1 > value2 ? 1 : -1;
    }
    return value1 > value2 ? -1 : 1;
  },
  /**
   * Defines the sort order of string values.
   * @param  {string, null} value1
   * @param  {string, null} value2
   * @param  {string} order
   * @param  {object} options Optional. An object with some or all of the following properties
   * @return {number}
   * A negative number if the reference string occurs before the compare string;
   * positive if the reference string occurs after the compare string;
   * 0 if they are equivalent.
   */
  compareString: function compareString(value1, value2, order, options) {
    // use default type compare is base if option is null or undefine
    var newOptions = _objectSpread({
      sensitivity: TYPE_COMPARE.BASE
    }, options);
    var langugeCompare = _lodash.default.get(_constants.default.LANGUAGE_PREFERENCES[1], 'value', 'en');
    var v1 = value1;
    var v2 = value2;
    if (order === TYPE_SORT.DESC) {
      v1 = value2;
      v2 = value1;
    }
    // localeCompare enables a case-insensitive sort of an array
    return _lodash.default.toString(v1).localeCompare(v2, langugeCompare, newOptions);
  }
};
var _default = SortUtil;
exports.default = _default;